"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateApi = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
class StateApi extends app_1.BaseApi {
    constructor(config) {
        super(config);
    }
    // Load states info form GET /api/danfoss-location/countries/{code}/divisions
    loadStatesInfo(countryCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = {
                countryCode,
            };
            return this.getData(params);
        });
    }
    // Load states translation from GET /api/danfoss-location/countries/{code}/divisions?language={language}
    loadTranslatedStates(countryCode, language) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = { countryCode, language };
            return this.getData(params);
        });
    }
    // Extended from BaseApi
    callApi(url, params) {
        const divisionsUrl = `${url}${StateApi.API_PATH}/${params.countryCode}/${StateApi.API_KEY_WORD}`;
        const additionalParams = params.language ? { language: params.language } : null;
        return super.callApi(divisionsUrl, additionalParams);
    }
    // Extended from BaseApi
    serialize(data, params) {
        const states = data.value;
        if (!states || states.length < 1) {
            return null;
        }
        if (this.canUseStorage()) {
            const retrievedStatesJSON = this.storageWithExpiration.getDataFromStorage(this.config.storageKey);
            const allStates = retrievedStatesJSON ? app_1.JSONService.parse(retrievedStatesJSON) : {};
            if (allStates) {
                allStates[params.countryCode] = data;
                return JSON.stringify(allStates);
            }
        }
        return null;
    }
    // Extended from BaseApi
    deserialize(data, params) {
        if (!data) {
            return null;
        }
        const allStates = app_1.JSONService.parse(data);
        if (allStates && allStates[params.countryCode]) {
            return allStates[params.countryCode];
        }
        return null;
    }
}
exports.StateApi = StateApi;
StateApi.STATE_PREFIX = 'region';
StateApi.API_KEY_WORD = 'divisions';
StateApi.API_PATH = '/danfoss-location/countries';
